
/* FRAME product gallery, options, details navigation and mobile assistance. */
(()=>{
 'use strict';
 const root=document.querySelector('[data-frame-product]');
 if(!root)return;
 const by=(s,base=root)=>base.querySelector(s);
 const all=(s,base=root)=>[...base.querySelectorAll(s)];
 const galleryItems=all('[data-frame-media]');
 const thumbs=all('[data-frame-thumb]');
 function showMedia(id){
   if(!id)return;
   const match=galleryItems.find(el=>el.dataset.frameMedia===String(id));
   if(!match)return;
   galleryItems.forEach(el=>{
     el.hidden=el!==match;
     if(el!==match){el.querySelectorAll('video').forEach(v=>v.pause());}
   });
   thumbs.forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.frameThumb===String(id))));
 }
 thumbs.forEach(el=>el.addEventListener('click',()=>showMedia(el.dataset.frameThumb)));
 const selector=by('[data-frame-variant]');
 const optionGroups=by('[data-frame-option-groups]');
 const optionChoices=optionGroups?[...optionGroups.querySelectorAll('[data-frame-option-choice]')]:[];
 const readOption=(option,index)=>option?.dataset?.[`option${index+1}`]||'';
 function refreshOptionButtons(){
   if(!selector||!optionGroups||optionGroups.hidden)return;
   const selected=selector.options[selector.selectedIndex];
   const variants=[...selector.options];
   optionGroups.querySelectorAll('[data-frame-option-index]').forEach(field=>{
     const index=Number(field.dataset.frameOptionIndex);
     const current=field.querySelector('[data-frame-option-current]');
     if(current)current.textContent=readOption(selected,index);
     field.querySelectorAll('[data-frame-option-choice]').forEach(button=>{
       const value=button.dataset.optionValue;
       const active=readOption(selected,index)===value;
       const possible=variants.some(variant=>readOption(variant,index)===value &&
         [0,1,2].every(i=>i===index||!readOption(selected,i)||readOption(variant,i)===readOption(selected,i)) && variant.dataset.available==='true');
       button.setAttribute('aria-pressed',String(active));
       button.classList.toggle('is-unavailable',!possible);
       button.title=possible?'': 'Unavailable with currently selected options';
     });
   });
 }
 if(selector&&optionGroups&&optionChoices.length&&optionChoices.length<=45){
   optionGroups.hidden=false;
   const selectRow=by('[data-frame-select-row]');
   if(selectRow)selectRow.hidden=true;
   optionChoices.forEach(button=>button.addEventListener('click',()=>{
     const index=Number(button.dataset.optionIndex);
     const clicked=button.dataset.optionValue;
     const current=selector.options[selector.selectedIndex];
     const matches=[...selector.options].filter(option=>readOption(option,index)===clicked);
     const exact=matches.find(option=>[0,1,2].every(i=>i===index||readOption(option,i)===readOption(current,i)));
     const next=exact||matches.find(option=>option.dataset.available==='true')||matches[0];
     if(next){selector.value=next.value;selector.dispatchEvent(new Event('change',{bubbles:true}));}
   }));
 }

 const availability=by('[data-frame-availability]');
 const availabilityLabel=by('[data-frame-availability-label]');
 const price=by('[data-frame-price]');
 const compare=by('[data-frame-compare]');
 const sku=by('[data-frame-sku]');
 const skuRow=by('[data-frame-sku-row]');
 const add=by('[data-frame-add]');
 const addLabel=by('[data-frame-add-label]');
 const selectedTitle=document.querySelector('[data-frame-spec-variant]');
 const stickyPrice=document.querySelector('[data-frame-sticky-price]');
 const stickyButton=document.querySelector('[data-frame-sticky-submit]');
 const stickyAction=document.querySelector('[data-frame-sticky-action]');
 function syncVariant(){
   if(!selector)return;
   const option=selector.options[selector.selectedIndex];
   if(!option)return;
   refreshOptionButtons();
   const available=option.dataset.available==='true';
   if(price)price.textContent=option.dataset.price||'';
   if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
   if(availability)availability.classList.toggle('is-unavailable',!available);
   if(availabilityLabel)availabilityLabel.textContent=available?'Available to order':'Currently unavailable';
   if(add)add.disabled=!available;
   if(addLabel)addLabel.textContent=available?'Add to cart':'Sold out';
   if(sku)sku.textContent=option.dataset.sku||'';
   if(skuRow)skuRow.hidden=!option.dataset.sku;
   if(selectedTitle)selectedTitle.textContent=option.textContent.replace(/\s+— Sold out$/, '').trim();
   if(stickyPrice)stickyPrice.textContent=option.dataset.price||'';
   if(stickyButton)stickyButton.disabled=!available;
   if(stickyAction)stickyAction.textContent=available?'Add to cart':'Sold out';
   const saleFlag=by('[data-frame-sale-flag]');
   if(saleFlag)saleFlag.hidden=!option.dataset.compare;
   syncRecordVisibility(option.value,option.dataset.sku||'',option.textContent.replace(/\s+— Sold out$/, '').trim());
   for(const field of ['sku','barcode','weight']){
     const value=option.dataset[field]||'';
     const target=document.querySelector(`[data-frame-spec-${field}]`);
     const row=document.querySelector(`[data-frame-spec-${field}-row]`);
     if(target)target.textContent=value;
     if(row)row.hidden=!value;
   }
   showMedia(option.dataset.media);
   document.querySelectorAll('[data-frame-table-variant]').forEach(button=>button.closest('tr')?.classList.toggle('frame-options__selected',button.dataset.frameTableVariant===option.value));
   try {const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({path:url.pathname},'',url.toString());} catch(_){}
 }
 function syncRecordVisibility(id,sku,title){
   document.querySelectorAll('[data-frame-record]').forEach(record=>{
     const rid=record.dataset.frameRecordVariantId||'';
     const rsku=record.dataset.frameRecordVariantSku||'';
     const rtitle=record.dataset.frameRecordVariantTitle||'';
     record.hidden=Boolean((rid&&rid!==id)||(rsku&&rsku!==sku)||(rtitle&&rtitle!==title));
   });
   document.querySelectorAll('[data-frame-record-container]').forEach(container=>{
     const records=[...container.querySelectorAll('[data-frame-record]')];
     const label=container.querySelector('[data-frame-record-empty]');
     if(label&&records.length)label.hidden=records.some(el=>!el.hidden);
   });
 }
 selector?.addEventListener('change',syncVariant);
 if(selector)syncVariant();
 else syncRecordVisibility(root.dataset.frameCurrentVariant||'',root.dataset.frameCurrentSku||'',root.dataset.frameCurrentTitle||'');
 document.querySelectorAll('[data-frame-table-variant]').forEach(button=>button.addEventListener('click',()=>{
   if(!selector)return;
   selector.value=button.dataset.frameTableVariant;
   selector.dispatchEvent(new Event('change',{bubbles:true}));
   by('#FrameProductForm')?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
 }));
 all('[data-frame-qty-change]').forEach(button=>button.addEventListener('click',()=>{
   const input=by('[name="quantity"]');if(!input)return;
   const step=Number(button.dataset.frameQtyChange)||0;
   const min=Number(input.min)||1;
   input.value=String(Math.max(min,(parseInt(input.value,10)||min)+step));
   input.dispatchEvent(new Event('change',{bubbles:true}));
 }));
 const dialog=by('[data-frame-lightbox]');
 const dialogImage=dialog?.querySelector('img');
 all('[data-frame-zoom]').forEach(button=>button.addEventListener('click',()=>{
   if(!dialog||!dialogImage||typeof dialog.showModal!=='function')return;
   dialogImage.src=button.dataset.zoomSrc;
   dialogImage.alt=button.dataset.zoomAlt||'';
   dialog.showModal();
 }));
 by('[data-frame-lightbox-close]')?.addEventListener('click',()=>dialog?.close());
 dialog?.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close();});
 const documentDialog=document.querySelector('[data-frame-doc-dialog]');
 if(documentDialog){
   const docFrame=documentDialog.querySelector('[data-frame-doc-frame]');
   const docImage=documentDialog.querySelector('[data-frame-doc-image]');
   const docHeading=documentDialog.querySelector('[data-frame-doc-heading]');
   const docOpen=documentDialog.querySelector('[data-frame-doc-open]');
   let trigger=null;
   document.querySelectorAll('[data-frame-doc-preview]').forEach(button=>button.addEventListener('click',()=>{
     const raw=button.dataset.frameDocSrc||'';
     let address;
     try{address=new URL(raw,window.location.href);}catch(_){return;}
     if(!['https:','http:'].includes(address.protocol))return;
     trigger=button;
     const label=button.dataset.frameDocLabel||'Document preview';
     if(docHeading)docHeading.textContent=label;
     if(docOpen)docOpen.href=address.href;
     const isPdf=button.dataset.frameDocKind==='pdf';
     if(docFrame){docFrame.hidden=!isPdf;docFrame.title=label;if(isPdf)docFrame.src=address.href;}
     if(docImage){docImage.hidden=isPdf;if(!isPdf){docImage.src=address.href;docImage.alt=label;}}
     if(typeof documentDialog.showModal==='function')documentDialog.showModal();
     else window.open(address.href,'_blank','noopener,noreferrer');
   }));
   documentDialog.querySelector('[data-frame-doc-close]')?.addEventListener('click',()=>documentDialog.close());
   documentDialog.addEventListener('click',event=>{if(event.target===documentDialog)documentDialog.close();});
   documentDialog.addEventListener('close',()=>{
     if(docFrame)docFrame.removeAttribute('src');
     if(docImage)docImage.removeAttribute('src');
     trigger?.focus({preventScroll:true});
   });
 }
 const sticky=document.querySelector('[data-frame-sticky-buy]');
 const purchase=by('#FrameProductForm');
 const footer=document.querySelector('.site-footer');
 if(sticky&&purchase&&'IntersectionObserver' in window){
   let formVisible=true,footerVisible=false;
   const render=()=>{
     const shouldShow=!formVisible&&!footerVisible&&window.matchMedia('(max-width: 900px)').matches;
     sticky.classList.toggle('is-visible',shouldShow);
     sticky.hidden=!shouldShow;
   };
   const formObserver=new IntersectionObserver(entries=>{formVisible=entries[0].isIntersecting;render();},{threshold:0});
   formObserver.observe(purchase);
   if(footer){const footerObserver=new IntersectionObserver(entries=>{footerVisible=entries[0].isIntersecting;render();});footerObserver.observe(footer);}
   window.addEventListener('resize',render,{passive:true});
   stickyButton?.addEventListener('click',()=>{
     const actualSubmit=by('[data-frame-add]');
     const form=actualSubmit?.form;
     if(!form||actualSubmit.disabled||stickyButton.disabled)return;
     if(typeof form.requestSubmit==='function')form.requestSubmit(actualSubmit);
     else actualSubmit.click();
   });
 }

 // Product navigation — positioned below the visible header.
 const nav=document.querySelector('[data-frame-section-nav]');
 if(nav){
   const sections=[...nav.querySelectorAll('a[href^="#"]')].map(link=>({
     link,target:document.getElementById(link.getAttribute('href').slice(1))
   })).filter(item=>{
     if(!item.target || (getComputedStyle(item.target).display==='none') ||
        (item.target.offsetParent===null && getComputedStyle(item.target).position!=='fixed')){
       item.link.remove();return false;
     }
     return true;
   });

   const wrapper=nav.parentElement;
   if(sections.length&&wrapper){
     const header=document.querySelector('.site-header');
     const strip=nav.querySelector('.frame-detail-nav__links');

     sections.sort((a,b)=>{
       const relationship=a.target.compareDocumentPosition(b.target);
       return relationship & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
     });

     if(strip)sections.forEach(item=>strip.appendChild(item.link));

     const last=sections[sections.length-1].target;

     const spacer=document.createElement('div');
     spacer.className='frame-detail-nav__spacer';
     spacer.setAttribute('aria-hidden','true');
     wrapper.insertBefore(spacer,nav);

     if(getComputedStyle(wrapper).position==='static'){
       wrapper.style.position='relative';
     }

     const docY=element=>
       element.getBoundingClientRect().top+window.scrollY;

     /* FIX:
        Measure the actual bottom of the visible header.

        Previously the value was capped to rect.height, which
        ignored the announcement bar's position above the header.

        With the Shopify header group sticky, rect.bottom gives
        the correct combined vertical offset.

        For a non-sticky header that leaves the viewport, this
        value naturally becomes zero.
     */
     const headerOffset=()=>{
       if(!header)return 0;

       const rect=header.getBoundingClientRect();

       return Math.max(
         0,
         Math.min(rect.bottom,window.innerHeight)
       );
     };

     let raf=0;
     let activeLink=null;
     let previousOffset=-1;
     let lastHeight=0;

     const update=()=>{
       raf=0;

       const navHeight=nav.offsetHeight;

       if(navHeight!==lastHeight){
         spacer.style.height=`${navHeight}px`;
         lastHeight=navHeight;
       }

       const origin=docY(spacer);
       const end=last.getBoundingClientRect().bottom+window.scrollY;
       const scroll=window.scrollY;
       const top=headerOffset();

       const shouldPin=scroll+top>=origin-0.5;
       const atEnd=scroll+top+navHeight>=end;

       if(!shouldPin){
         nav.classList.remove('is-pinned','is-released');
       }else if(atEnd){
         nav.classList.remove('is-pinned');
         nav.classList.add('is-released');

         const bottomTop=Math.max(
           0,
           end-docY(wrapper)-navHeight
         );

         nav.style.setProperty(
           '--frame-detail-nav-end',
           `${bottomTop}px`
         );
       }else{
         nav.classList.remove('is-released');
         nav.classList.add('is-pinned');

         nav.style.setProperty(
           '--frame-detail-nav-top',
           `${top}px`
         );
       }

       const scrollMargin=Math.ceil(top+navHeight+18);

       if(previousOffset!==scrollMargin){
         sections.forEach(item=>{
           item.target.style.scrollMarginTop=
             `${scrollMargin}px`;
         });
         previousOffset=scrollMargin;
       }

       const probe=
         top+navHeight+Math.min(100,window.innerHeight*.15);

       let selected=sections[0].link;

       for(const item of sections){
         if(item.target.getBoundingClientRect().top<=probe){
           selected=item.link;
         }
       }

       if(selected!==activeLink){
         activeLink?.classList.remove('is-active');
         selected.classList.add('is-active');
         activeLink=selected;

         // Scroll only the horizontal tabs, not the page.
         if(strip){
           const bar=strip.getBoundingClientRect();
           const tab=selected.getBoundingClientRect();

           if(tab.left<bar.left+12){
             strip.scrollLeft+=tab.left-bar.left-12;
           }else if(tab.right>bar.right-12){
             strip.scrollLeft+=tab.right-bar.right+12;
           }
         }
       }
     };

     lastHeight=nav.offsetHeight;
     spacer.style.height=`${lastHeight}px`;
     nav.classList.add('is-managed');

     const request=()=>{
       if(!raf)raf=requestAnimationFrame(update);
     };

     window.addEventListener('scroll',request,{passive:true});
     window.addEventListener('resize',request,{passive:true});
     window.addEventListener('orientationchange',request,{passive:true});

     if('ResizeObserver' in window){
       const observer=new ResizeObserver(request);
       observer.observe(nav);
       observer.observe(last);

       if(header)observer.observe(header);
     }

     document.addEventListener('shopify:section:load',request);
     request();
   }
 }
})();
